import { useState } from 'react'
import { Drawer } from 'antd'
import { DRAWER_SIZE } from '@/const/drawer.ts'
import type { ContractDocumentSearch } from './contract-document-search.ts'
import { ContractDocumentsTable } from './contract-documents-table.tsx'

export function OrderContractsDrawer({
  order,
  onClose
}: {
  order: { type: 'rental' | 'service'; id: number; orderNo: string }
  onClose: () => void
}) {
  const [open, setOpen] = useState(true)
  const [search, setSearch] = useState<ContractDocumentSearch>({ current: 1, pageSize: 20 })
  return (
    <Drawer
      open={open}
      size={DRAWER_SIZE}
      title={`合同文件 · ${order.orderNo}`}
      closable={{ placement: 'end' }}
      onClose={() => setOpen(false)}
      afterOpenChange={(visible) => {
        if (!visible) {
          onClose()
        }
      }}
    >
      <ContractDocumentsTable order={order} search={search} onSearchChange={setSearch} />
    </Drawer>
  )
}
